@import '../../utils/control-density.css';
@import '../../utils/chrome-layout.css';
@import '../../utils/search-control.css';
@import '../../utils/typography.css';

:host {
  display: block;
  flex: 0 0 var(--dimension-size-600);
  width: 100%;
  min-width: 0;
  height: var(--dimension-size-600);
  box-sizing: border-box;
  background: transparent;
}

.panel-tool-search {
  position: relative;
  width: 100%;
  height: 100%;
  background: transparent;
}

.panel-tool-search::after {
  content: '';
  position: absolute;
  inset: auto 0 0;
  height: var(--dimension-stroke-width-012);
  background-color: var(--color-border-tertiary);
  pointer-events: none;
}

.select-search {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  height: var(--dimension-size-400);
  padding: 0;
}

.select-search::after {
  display: none;
}

.panel-tool-search__filter-group {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: var(--dimension-space-100);
}

.panel-tool-search__divider,
.panel-tool-search__filter {
  flex: 0 0 auto;
}
